





















































































































































import {
  computed,
  defineComponent, PropType, Ref, ref, watch,
} from 'vue';
import { DataPagination } from 'vuetify';

import api from '@/api';
import { App, KeyValue, TableRow } from '@/types';
import store from '@/store';
import WorkspaceOptionMenu from '@/components/WorkspaceOptionMenu.vue';

export default defineComponent({
  name: 'TableDetail',

  components: {
    WorkspaceOptionMenu,
  },

  props: {
    workspace: {
      type: String as PropType<string>,
      required: true,
    },

    table: {
      type: String as PropType<string>,
      required: true,
    },

    apps: {
      type: Object as PropType<{ network_visualizations: App[]; table_visualizations: App[] }>,
      required: true,
    },
  },
  setup(props) {
    const rowKeys: Ref<KeyValue[][]> = ref([]);
    const headers: Ref<Array<keyof TableRow>> = ref([]);
    const editing = ref(false);
    const tableSize = ref(1);
    const pagination: Ref<DataPagination> = ref({} as DataPagination);
    const loading = ref(true);
    const loadingTables = ref(true);
    const columnTypes = ref({});

    api.columnTypes(props.workspace, props.table).then((data) => { columnTypes.value = data; });

    const tables = computed(() => store.getters.tables);
    const dataTableHeaders = computed(() => headers.value.map((header) => ({
      text: header,
      value: header,
    })));
    const dataTableRows = computed(() => {
      const result = [] as TableRow[];

      rowKeys.value.forEach((rowKey) => {
        const obj = {} as TableRow;
        rowKey.forEach((entry) => {
          obj[entry.key] = entry.value;
        });

        result.push(obj);
      });

      return result;
    });

    async function update() {
      loading.value = true;

      const result = await api.table(props.workspace, props.table, {
        offset: (pagination.value.page - 1) * pagination.value.itemsPerPage,
        limit: pagination.value.itemsPerPage,
      });

      const {
        results: rows,
        count,
      } = result;

      tableSize.value = count;

      const newRowKeys: KeyValue[][] = [];
      let newHeaders: Array<keyof TableRow> = [];
      if (rows) {
        rows.forEach((row) => {
          const rowData: KeyValue[] = [];
          Object.entries(row)
            .filter(([key]) => key !== '_rev')
            .forEach(([key, value]) => {
              rowData.push({
                key,
                value,
              });
            });

          newRowKeys.push(rowData);
        });

        newHeaders = rows.length > 0 ? Object.keys(rows[0]).filter((d) => d !== '_rev') : [];
      }

      rowKeys.value = newRowKeys;
      headers.value = newHeaders;

      loading.value = false;
    }

    watch([() => props.workspace, () => props.table, pagination], () => update());
    watch(tables, () => { loadingTables.value = false; });

    store.dispatch.fetchWorkspace(props.workspace);

    return {
      rowKeys,
      headers,
      editing,
      tableSize,
      pagination,
      loading,
      loadingTables,
      dataTableHeaders,
      dataTableRows,
      columnTypes,
      tables,
    };
  },
});
